<template>
    <div class="power">
        <a-button class="btn btn-info" @click="onOffClicked"><fa-icon icon="power-off" /></a-button>
    </div>
</template>

<style scoped lang="scss">
    .power {
        position:fixed;
        bottom:0;
        right:0;
        margin:1rem 2rem 2rem 0;
        a {
            color: red;
            background: darkgray;
            font-size:2.5rem;
            svg {
                width: 1.2em;
            }
        }
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";
import { AUGGIEAVAILABLE } from "@/main";
import { ButtonClicked } from "@/shared/enums/ButtonClicked";
import { confirmOk, confirmYesNo } from "@/shared/components/common/AlertDialog.vue";
import { Global } from "@/support/GlobalData";
import Toast from "@/shared/support/Toast";

export default defineComponent({
    name: "PowerOff",
    methods: {
        onOffClicked(): void {
            confirmYesNo("Are you sure you want to shut down this device?")
                .then((clicked: ButtonClicked): void => {
                    if (clicked === ButtonClicked.Ok) {
                        const shutdown = (): void => {
                            Toast.success("Shutting down ....");
                            if (AUGGIEAVAILABLE) {
                                setTimeout((): void => {
                                    Auggie.System.ShutDown();
                                }, 2000); // slight delay so the toast is shown
                            }
                        };
                        if (Global.IsAir()) {
                            shutdown();
                        } else {
                            confirmOk("Please make sure to power off the device once it has shut down.")
                                .then(shutdown);
                        }
                    }
                });
        }
    }
});

</script>
